import React from 'react';
import styles from './header_section.module.scss';

interface Props {
  title: string;
  total: number;
  linkText: string;
  linkValue: string;
  secondaryText: string;
}

const HeaderSection = ({ title, total, linkText, linkValue, secondaryText }: Props) => {

  const formatTotalValue = (): string => {
    if (total < 1000) return String(total);

    const floatValue = (total / 1000).toFixed(1);

    if (floatValue[2] === '0') return floatValue[0] + 'k';

    return floatValue + 'k';
  };

  const linkElement = (
    <a href={linkValue} className='text-primary-alt fw-bold' data-testid='link-element'>
      {linkText}
    </a>
  );

  const primaryText = (
    <span className='text-primary-alt fw-bold' data-testid='primary-text-element'>
      {linkText}
    </span>
  );

  return (
    <div className={styles.container} data-testid='header-section'>
      <h2>{title}</h2>
      <div className={styles.contentContainer}>
        <span className={styles.total} data-testid='total-value'>{formatTotalValue()}</span>
        <div className={styles.textContainer}>
          {total > 0 ? linkElement : primaryText}
          <span>{secondaryText}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
